function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "good team");

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 389.95692,
  y1: 255.2818,
  x2: 533.95692,
  y2: 255.2818,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 248.8673,
  cy: 443.49824,
  rx: 39.5,
  ry: 12.40027,
  transform: "translate(-296.29734 483.90373) rotate(-69.08217)",
  fill: "#2f2e41"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1153.37778,543.01392c15.6657,116.58889-5.66624,233.30465-114.16871,278.75349S805.90441,816.10117,760.45558,707.5987s61.78473-173.424,114.16871-278.75349C981.00055,214.95244,1104.72832,180.94968,1153.37778,543.01392Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#f2f2f2"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 916,
  cy: 794.4364,
  rx: 170,
  ry: 23.12721,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 858.75178,
  y: 753.63241,
  width: 24,
  height: 43,
  transform: "translate(313.59438 1787.2135) rotate(-105.45227)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 844.35943,
  cy: 777.24047,
  rx: 7.5,
  ry: 20,
  transform: "translate(-218.60626 219.34424) rotate(-15.45227)",
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 965.36129,
  cy: 688.06892,
  rx: 39.5,
  ry: 12.40027,
  transform: "translate(111.82337 1518.54826) rotate(-82.28111)",
  fill: "#2f2e41"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 915.58486,
  cy: 728.29931,
  r: 79,
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 858.75178,
  y: 739.63241,
  width: 24,
  height: 43,
  transform: "translate(327.08832 1769.4834) rotate(-105.45227)",
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 844.35943,
  cy: 763.24047,
  rx: 7.5,
  ry: 20,
  transform: "translate(-214.87616 218.83818) rotate(-15.45227)",
  fill: "#2f2e41"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 936.32904,
  cy: 683.0429,
  r: 27,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 944.96335,
  cy: 671.11583,
  r: 9,
  fill: "#3f3d56"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1048.85766,816.30571c29.23451-1.46311,51.62459-28.80779,50.00965-61.07607s-26.62336-57.24079-55.85786-55.77768-33.822,24.41244-32.20709,56.68072S1019.62316,817.76882,1048.85766,816.30571Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#f56a00"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M925.34085,728.59207a18,18,0,0,1-2.90424-35.88266c9.90873-.802,12.611,7.06452,13.413,16.97325S935.24957,727.79008,925.34085,728.59207Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("polyline", {
  points: "49.464 361.025 491.957 361.025 560.56 394.447 669.866 447.699 741.334 313.887 943.574 313.887",
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 222.81141,
  cy: 375.02535,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 350.54143,
  cy: 361.02535,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 560.3836,
  cy: 394.47845,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 855.37911,
  cy: 313.88689,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 712.44314,
  cy: 367.10773,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 427.57554,
  cy: 581.44087,
  r: 14.75556,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 170,
  cy: 809.4364,
  rx: 170,
  ry: 23.12721,
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 160.80455,
  cy: 696.4364,
  r: 79,
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 124.80455,
  y: 758.4364,
  width: 24,
  height: 43,
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 172.80455,
  y: 758.4364,
  width: 24,
  height: 43,
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 144.80455,
  cy: 801.9364,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.80455,
  cy: 800.9364,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 162.80455,
  cy: 676.4364,
  r: 27,
  fill: "#fff"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 162.80455,
  cy: 676.4364,
  r: 9,
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M126.215,656.68687c-6.37889-28.56758,14.01185-57.43391,45.544-64.47476s62.2651,10.41,68.644,38.97759-14.51861,39.1038-46.05075,46.14465S132.59385,685.25445,126.215,656.68687Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#f56a00"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 133.80455,
  cy: 469.4364,
  r: 79,
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 97.80455,
  y: 531.4364,
  width: 24,
  height: 43,
  fill: "#2f2e41"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 145.80455,
  y: 531.4364,
  width: 24,
  height: 43,
  fill: "#2f2e41"
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 117.80455,
  cy: 574.9364,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 165.80455,
  cy: 573.9364,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.80455,
  cy: 449.4364,
  r: 27,
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.80455,
  cy: 449.4364,
  r: 9,
  fill: "#3f3d56"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M99.215,429.68687c-6.37889-28.56758,14.01185-57.43391,45.544-64.47476s62.2651,10.41,68.644,38.97759-14.51861,39.1038-46.05075,46.14465S105.59385,458.25445,99.215,429.68687Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#f56a00"
});

var _ref41 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.8673,
  cy: 466.49824,
  rx: 12.40027,
  ry: 39.5,
  transform: "translate(-413.89514 311.35892) rotate(-64.62574)",
  fill: "#2f2e41"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M137.04308,531.65459c0,7.732,19.90861,23,42,23s42.80455-21.768,42.80455-29.5-20.71316,1.5-42.80455,1.5S137.04308,523.92261,137.04308,531.65459Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#fff"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 835.47438,
  y: 564.70968,
  width: 126.12903,
  height: 64.16129,
  fill: "#f56a00"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 825.60342,
  y: 575.12903,
  width: 126.12903,
  height: 64.16129,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 226.60342,
  y: 199,
  width: 36,
  height: 36,
  fill: "#ff6584"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 217.60342,
  y: 187,
  width: 36,
  height: 36,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 906.05209,
  cy: 189.47009,
  r: 79,
  fill: "#2f2e41"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 974.58547,
  y: 279.57761,
  width: 24,
  height: 43,
  transform: "matrix(-0.98401, 0.17813, -0.17813, -0.98401, 1968.98075, 387.87775)",
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 927.35317,
  y: 288.12802,
  width: 24,
  height: 43,
  transform: "translate(1876.79468 413.25547) rotate(169.73894)",
  fill: "#2f2e41"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 939.06461,
  cy: 336.10285,
  rx: 20,
  ry: 7.5,
  transform: "translate(-36.79955 652.79249) rotate(-40.26106)",
  fill: "#2f2e41"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 985.3129,
  cy: 327.73058,
  rx: 20,
  ry: 7.5,
  transform: "translate(-20.43292 680.69811) rotate(-40.26106)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("circle", {
  cx: 900.52141,
  cy: 170.14623,
  r: 27,
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  cx: 889.4245,
  cy: 160.46817,
  r: 9,
  fill: "#3f3d56"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M1010.41514,137.24473c1.188-29.247-24.01866-54.01935-56.30069-55.33066s-59.41488,21.335-60.60291,50.582,21.2521,35.89214,53.53414,37.20345S1009.22711,166.49171,1010.41514,137.24473Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#f56a00"
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 875.1496,
  cy: 208.79579,
  rx: 12.40027,
  ry: 39.5,
  transform: "translate(434.06107 981.45545) rotate(-77.0899)",
  fill: "#2f2e41"
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1030.22362,
  cy: 234.58437,
  rx: 12.40027,
  ry: 39.5,
  transform: "translate(529.35145 1152.63631) rotate(-77.0899)",
  fill: "#2f2e41"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M969.79256,254.32118a18,18,0,1,1-35.42423,6.41281c-1.77085-9.78213,5.79238-13.24363,15.57451-15.01448S968.02171,244.53905,969.79256,254.32118Z",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#fff"
});

var _ref58 = /*#__PURE__*/React.createElement("line", {
  x1: 712.60342,
  y1: 99,
  x2: 803.60342,
  y2: 169,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref59 = /*#__PURE__*/React.createElement("circle", {
  cx: 669.60342,
  cy: 68,
  r: 68,
  fill: "#ff6584"
});

var _ref60 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 935.70955,
  cy: 706.84021,
  rx: 39.5,
  ry: 12.40027,
  transform: "translate(67.55305 1505.41525) rotate(-82.28111)",
  fill: "#2f2e41"
});

var _ref61 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.81141,
  cy: 786.02535,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref62 = /*#__PURE__*/React.createElement("rect", {
  x: 256.60342,
  y: 770,
  width: 36,
  height: 36,
  fill: "#ff6584"
});

var _ref63 = /*#__PURE__*/React.createElement("circle", {
  cx: 256.81141,
  cy: 794.02535,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref64 = /*#__PURE__*/React.createElement("circle", {
  cx: 461.95692,
  cy: 255.02535,
  r: 13.68536,
  fill: "#f56a00"
});

var _ref65 = /*#__PURE__*/React.createElement("circle", {
  cx: 727.72056,
  cy: 679.25214,
  r: 6.53537,
  fill: "#ff6584"
});

var _ref66 = /*#__PURE__*/React.createElement("line", {
  x1: 759.73934,
  y1: 787.72466,
  x2: 759.73934,
  y2: 713.31328,
  fill: "#3f3d56",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref67 = /*#__PURE__*/React.createElement("circle", {
  cx: 759.73934,
  cy: 713.31328,
  r: 10.52282,
  fill: "#3f3d56"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M801.78241,792.89275s-1.50326-32.33193-32.32009-28.57378",
  transform: "translate(-42.04308 -33.7182)",
  fill: "#3f3d56"
});

const SvgUndrawGoodTeamM7Uu = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b32a285a-6b04-4396-8e15-f52ff515c3cb",
    "data-name": "Layer 1",
    width: 500.91385,
    height: 400.5636,
    viewBox: "0 0 1115.91385 832.5636",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUndrawGoodTeamM7Uu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/undraw_good_team_m7uu.d71c3e3d.svg";
export { ForwardRef as ReactComponent };